/**
 * Normalize a DOI to bare form: strip a leading doi.org URL prefix and trim.
 * Returns '' for empty/undefined input.
 *
 * DOIs reach the frontend in mixed formats depending on the suggestion source
 * (bare from most paths, but `https://doi.org/…` from refutation_finder/OpenAlex),
 * so normalize before logging or keying analytics on a DOI.
 */
export function normalizeDoi(doi: string | null | undefined): string {
  if (!doi) return '';
  return doi.replace(/^https?:\/\/doi\.org\//i, '').trim();
}

export default normalizeDoi;
